import { Outlet, type RouteObject } from "react-router-dom";
import InvitationPage from "./Invitation.page";

export const invitationRoutes: RouteObject[] = [
	{
		element: <Outlet />,
		children: [
			{
				path: "",
				element: <InvitationPage />,
			},
		],
	},
];
